import React from 'react';
import { CURRENCIES } from './CurrenciesList';

/**
 * Price Property - Allows configuring currency symbol and decimal places for price field
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PriceProperty = _ref => {
  let {
    field,
    updateField,
    selectedField
  } = _ref;
  if (field.type !== 'price') {
    return null;
  }
  const currencySymbol = field.currencySymbol || '$';
  const decimalPlaces = field.decimalPlaces !== undefined ? field.decimalPlaces : 2;

  // Find the currency that matches the current symbol, or default to USD
  const selectedCurrency = CURRENCIES.find(c => c.symbol === currencySymbol) || CURRENCIES[0];
  return /*#__PURE__*/_jsxs("div", {
    className: "property-section",
    children: [/*#__PURE__*/_jsx("label", {
      className: "section-label",
      children: "Price Settings"
    }), /*#__PURE__*/_jsxs("div", {
      className: "price-config-section",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "property-item",
        children: [/*#__PURE__*/_jsx("label", {
          className: "property-label",
          children: "Currency Symbol"
        }), /*#__PURE__*/_jsx("select", {
          value: selectedCurrency.symbol,
          onChange: e => {
            const selected = CURRENCIES.find(c => c.symbol === e.target.value);
            if (selected) {
              updateField(selectedField, {
                currencySymbol: selected.symbol
              });
            }
          },
          className: "property-input",
          children: CURRENCIES.map(curr => /*#__PURE__*/_jsxs("option", {
            value: curr.symbol,
            children: [curr.symbol, " - ", curr.name, " (", curr.code, ")"]
          }, curr.code))
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "property-item",
        children: [/*#__PURE__*/_jsx("label", {
          className: "property-label",
          children: "Decimal Places"
        }), /*#__PURE__*/_jsx("input", {
          type: "number",
          min: "0",
          max: "10",
          value: decimalPlaces,
          onChange: e => updateField(selectedField, {
            decimalPlaces: parseInt(e.target.value) || 2
          }),
          className: "property-input"
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "property-item",
        children: /*#__PURE__*/_jsxs("label", {
          className: "checkbox-label",
          children: [/*#__PURE__*/_jsx("input", {
            type: "checkbox",
            checked: field.currencyEditable !== false,
            onChange: e => updateField(selectedField, {
              currencyEditable: e.target.checked
            })
          }), "Currency selectbox editable"]
        })
      })]
    })]
  });
};